module.exports = __webpack_public_path__ + "img/Biene-auf-Blume-v2-100.fac5aa10.png";